
export default {
  methods: {
    initFloor(){
      if(this.$model3D.sceneHelpers.getSceneObjectByName({ objectName: "floor" })) {
        this.$model3D.sceneHelpers.getSceneObjectByName({ objectName: "floor" }).material.roughness = 1;
        this.$model3D.sceneHelpers.getSceneObjectByName({ objectName: "floor" }).material.metalness = 0;
      }
    }
  }
};
